import React, {useEffect, useState} from "react"
import {LocalizationProvider} from "@mui/x-date-pickers"
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment"
import {AuthProvider} from "react-oidc-context"
import {ToastContainer} from "react-toastify"
import App from "./App"
import GlobalContextProvider from "../anwendungskonfigurator/context-provider/GlobalContextProvider"
import Gatekeeper from "../anwendungskonfigurator/components/Gatekeeper"
import DynamicThemeProvider from "./context-provider/DynamicThemeProvider"
import TomClient from "../anwendungskonfigurator/services/tomClient"
import {backendBaseUrl} from "../anwendungskonfigurator/misc/utils"
import {UserManager, WebStorageStateStore} from "oidc-client-ts"
import {applyBlankoLogin} from "../anwendungskonfigurator/misc/auth-functions"

export const DEFAULT_TENANT = "teckpro"

export const ROLES = Object.freeze({
    ADMIN: "admin",
    USER: "user",
})

const url = window.location.origin + window.location.pathname
const AUTHORITY = window._env_.AUTHORITY
const CLIENT_ID = window._env_.CLIENT_ID

const silentRedirectUri = process.env.WC_CONTAINER_ID
    ? url
    : window.location.origin + "/silent-renew.html"

export const onSigninCallback = (user) => {
    TomClient.setToken(user.access_token)
    TomClient.callHallink({href: backendBaseUrl + "/user/me", methods: ["PUT"]})
    window.history.replaceState(
        {},
        document.title,
        window.location.pathname,
    )
}

export const userManager = new UserManager({
    authority: AUTHORITY,
    client_id: CLIENT_ID,
    redirect_uri: url,
    response_type: "code",
    silent_redirect_uri: silentRedirectUri,
    automaticSilentRenew: true,
    validateSubOnSilentRenew: true,
    silentRequestTimeout: 10000,
    filterProtocolClaims: true,
    revokeAccessTokenOnSignout: true,
    userStore: new WebStorageStateStore({store: window.sessionStorage}),
})

const reAuthHandler = () => {
    if (globalThis._env_.AUTH_USER) {
        return applyBlankoLogin(userManager)
    }
    return userManager.signinRedirect()
}

TomClient.setReAuthHandler(reAuthHandler)

userManager.events.addAccessTokenExpired(() => {
    if (globalThis._env_.AUTH_USER) {
        applyBlankoLogin(userManager)
        return
    }
    userManager.signinSilent().catch(() => userManager.signinRedirect())
})

const AppWrapper = () => {
    const [initPending, setInitPending] = useState(true)
    useEffect(() => {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const initUrl = urlParams.get("initUrl")
        if (initUrl) {
            sessionStorage.setItem("initUrl", initUrl)
        }
        setInitPending(false)
    }, [])
    return (
        !initPending
            ? <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
                <GlobalContextProvider>
                    <Gatekeeper>
                        <DynamicThemeProvider>
                            <LocalizationProvider
                                dateAdapter={AdapterMoment}
                                adapterLocale="de">
                                <App />
                            </LocalizationProvider>
                            <ToastContainer theme="colored" />
                        </DynamicThemeProvider>
                    </Gatekeeper>
                </GlobalContextProvider>
            </AuthProvider>
            : <></>
    )
}

export default AppWrapper
